/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const createNotificationPolicyBodyNameMax = 120;

export const createNotificationPolicyBodyStepsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const createNotificationPolicyBodyStepsItemPositionMin = 0;
export const createNotificationPolicyBodyStepsItemPositionMax = 9007199254740991;

export const createNotificationPolicyBodyStepsItemDelayMinutesMin = 0;
export const createNotificationPolicyBodyStepsItemDelayMinutesMax = 1440;

export const createNotificationPolicyBodyStepsItemTargetOneUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const createNotificationPolicyBodyStepsItemTargetTwoScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const createNotificationPolicyBodyStepsItemTargetThreeTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const createNotificationPolicyBodyStepsItemChannelsMax = 3;

export const CreateNotificationPolicyBody = zod.object({
  name: zod.string().min(1).max(createNotificationPolicyBodyNameMax),
  enabled: zod.boolean(),
  steps: zod
    .array(
      zod.object({
        id: zod.uuid().regex(createNotificationPolicyBodyStepsItemIdRegExp),
        position: zod
          .int()
          .min(createNotificationPolicyBodyStepsItemPositionMin)
          .max(createNotificationPolicyBodyStepsItemPositionMax),
        delayMinutes: zod
          .int()
          .min(createNotificationPolicyBodyStepsItemDelayMinutesMin)
          .max(createNotificationPolicyBodyStepsItemDelayMinutesMax),
        condition: zod.enum(['not-acknowledged', 'not-resolved']),
        target: zod.union([
          zod.object({
            kind: zod.literal('user'),
            userId: zod.uuid().regex(createNotificationPolicyBodyStepsItemTargetOneUserIdRegExp),
          }),
          zod.object({
            kind: zod.literal('schedule'),
            scheduleId: zod
              .uuid()
              .regex(createNotificationPolicyBodyStepsItemTargetTwoScheduleIdRegExp),
          }),
          zod.object({
            kind: zod.literal('team'),
            teamId: zod.uuid().regex(createNotificationPolicyBodyStepsItemTargetThreeTeamIdRegExp),
          }),
        ]),
        channels: zod
          .array(zod.enum(['email', 'sms', 'voice']))
          .min(1)
          .max(createNotificationPolicyBodyStepsItemChannelsMax),
      }),
    )
    .min(1),
});

export type CreateNotificationPolicyBody = zod.input<typeof CreateNotificationPolicyBody>;
export type CreateNotificationPolicyBodyOutput = zod.output<typeof CreateNotificationPolicyBody>;
